import h, { FunctionComponent } from 'preact';
import { BasketMessage, Surcharge } from '../types';

const Messages: FunctionComponent<MessagesProps> = ({ errors, warnings }) => {
    if (errors.length === 0 && warnings.length === 0) {
        return null;
    }

    return <div id="js-alerts-wrapper" class="basket__alerts">
        {(errors.length > 0) ? <div id="js-basket-errors">
            <div class="alert alert-danger">
                <h2 class="text-md mb-3 mt-2 font-weight-bold">
                    The following issues will need to be addressed before you can check out:
                </h2>
                <ul>
                    {errors.map((error, idx) => (
                        <li class="js-basket-error mb-2" key={'error-' + idx}>
                            <button class="js-error-button border-0 bg-transparent text-underline alert-danger text-hover-black text-left align-top">
                                {error.message}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div> : null}
        {(warnings.length > 0 ) ? <div id="js-basket-warnings">
            <div class="alert alert-warning">
                <h2 class="text-md mb-3 mt-2 font-weight-bold">
                    Advisory notes:
                </h2>
                <ul>
                    {warnings.map((warning, idx) => (
                        <li class="js-basket-warning mb-2" key={'warning-' + idx}>
                            <button class="js-warning-button border-0 bg-transparent text-underline alert-warning text-hover-black text-left">
                                {warning.description}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div> : null}
    </div>;
}

interface MessagesProps {
    errors: Array<BasketMessage>;
    warnings: Array<Surcharge>;
}

export default Messages;
